export default "__VITE_ASSET__DDh22CBi__"